import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterSites',
    standalone: false
})
export class FilterSitesPipe implements PipeTransform {
  transform(sites: any[], search: string): any[] {
    if (!search) return sites;
    return sites.filter(site =>
      site.name.toLowerCase().includes(search.toLowerCase())
    );
  }
}